import React from "react";
import _ from "lodash";
import { useSelector } from "react-redux";
import { Table, Segment } from "semantic-ui-react";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import ListItem from "./list-item";
import "./list.css";

const List = ({ banners, start, pageBy }) => {
  const search = useSelector((state) => state.search);
  const list = _.slice(banners, start, start + pageBy);

  return (
    <Segment attached="bottom" className="bm-segment-list">
      <Table selectable padded unstackable>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Ad number</Table.HeaderCell>
            <Table.HeaderCell>Advertiser</Table.HeaderCell>
            <Table.HeaderCell>Banner</Table.HeaderCell>
            <Table.HeaderCell>Ad served</Table.HeaderCell>
            <Table.HeaderCell>Retailer</Table.HeaderCell>
            <Table.HeaderCell>Type</Table.HeaderCell>
            <Table.HeaderCell>Last user</Table.HeaderCell>
            <Table.HeaderCell>Copy URL</Table.HeaderCell>
            <Table.HeaderCell>Edit</Table.HeaderCell>
            <Table.HeaderCell>Delete</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        {list && (
          <TransitionGroup component="tbody">
            {_.map(list, (banner) => (
              <CSSTransition timeout={500} key={banner.id} classNames="item">
                <ListItem key={banner.id} banner={banner} />
              </CSSTransition>
            ))}
          </TransitionGroup>
        )}
        {search && list.length === 0 && (
          <Table.Footer>
            <Table.Row>
              <Table.Cell colSpan="10">
                Sorry, no results for {search.term}
              </Table.Cell>
            </Table.Row>
          </Table.Footer>
        )}
      </Table>
    </Segment>
  );
};

export default List;
